import Swiper, { Scrollbar } from "swiper";

export default () => ({
  swiper: null,

  initSlider() {
    this.swiper = new Swiper(this.$refs.slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      rewind: true,
      scrollbar: {
        el: this.$el.querySelector(".swiper-scrollbar"),
      },
      modules: [Scrollbar],
    });
  },
});
